export default {
  path: "/tips",
  name: "tips",
  component: () => import("@/views/Page.vue"),
  children: [
    {
      path: "/didi/index",
      name: "didiIndex",
      component: () => import("@/components/tips/index.vue"),
      meta: {
        title: "企业滴滴权限说明"
      }
    },
    {
      path: "/tips/scanning",
      name: "scanningTips",
      component: () => import("@/components/tips/index.vue"),
      meta: {
        flag: 1,
        title: "扫码结果"
      }
    },
    {
      path: "/tips/test",
      name: "test",
      component: () => import("@/components/tips/test.vue"),
      meta: {
        flag: 1,
        title: "test"
      }
    }
  ]
};
